export const menadzerski_ugovor_poseban_ugovor= {
    templateId: 223,
    category: 15,
    templateTitle: "Menadžerski ugovor - kao poseban ugovor obveznog prava, koji se sklapa uz radni odnos",
    templateDescription: `<p>Menadžerski ugovor često se zaključuje kao poseban i samostalan ugovor, uz postojeći ugovor o radu (ili čak ukoliko nije zaključen ugovor o radu). Menadžerskim ugovorom, menadžer (direktor, član uprave, izvršni direktor i sl.) i poslodavac slobodno reguliraju međusobna prava i obveze.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Zakonom o radu određeno je da je radnik (zaposlenik, uposlenik, djelatnik, namještenik, službenik i slično) fizička osoba koja u radnom odnosu obavlja određene poslove za poslodavca.</p>
    <p>Treba naglasiti da Zakon o radu također propisuje da i <strong>član uprave ili izvršni direktor ili druga fizička osoba koja je prema posebnom zakonu, pojedinačno i samostalno ili zajedno i skupno, u drugom svojstvu ovlaštena voditi poslove poslodavca, može kao radnik u radnom odnosu obavljati određene poslove za poslodavca.</strong></p>
    <p>Dakle,  s obzirom na uređivanje pravnog statusa <strong>osoba koje upravljaju, vode i odlučuju o poslovanju</strong> poslodavca (određene su od strane skupštine društva kao osobe ovlaštene za zastupanje), navedene osobe mogu biti:</p>
    
    <p>1. radnici poslodavca koji ugovorom o radu (radnopravnim odnosom) uređuju sva međusobna prava i obveze (predložak takvog ugovora možete pogledati <a class="local-link" href="/contract?template=225">ovdje</a>),</p>
      <p>2. radnici poslodavca,  pri čemu <strong>mogu u jednom ugovoru</strong> (mješovitom ugovoru koji sadrži elemente radnog prava, ali i elemente obveznog prava) urediti elemente radnog odnosa, ali i takva dodatna prava i obveze koja se odnose na dodatni status osobe koja upravlja, vodi i odlučuje o poslovanju (tzv. ugovor o radu menadžera), </p>
      <p>3. radnici poslodavca  koji dodatno, <strong>uz već postojeći <a class="local-link" href="/contract?template=225">"osnovni"</a> ugovor o radu zaključuju i poseban menadžerski ugovor</strong>, kojim slobodno uređuju dodatna međusobna prava i obveze,</p>
      <p>4. <strong>isključivo menadžeri <strong> (zaključenjem menadžerskog ugovora), a bez da uspostavljaju radni odnos s poslodavcem. </p>    
    <p>Predložak ugovora o radu menadžera za opcije 1. možete pogledati <a class="local-link" href="/contract?template=224">ovdje</a>.</p>
    <p>Ovim tekstom te predloškom u nastavku reguliraju se opcije 3. i 4. u prethodno navedenom - menadžerski ugovor. </p>
    <p>Radi pojašnjenja, bitno je naglasiti da u stvarnosti veliki broj “menadžera” zapravo ne ulaze u kategoriju “pravih” menadžera (osoba ovlaštenih voditi poslove poslodavca kao članovi uprave, direktori, izvršni direktori i sl.), nego su npr. rukovoditelji odjela, voditelji i sl.. Navedene osobe se u pravnom smislu ne mogu smatrati osobama koja upravljaju, vode i odlučuju o poslovanju, što dovodi do isključive primjene Zakona o radu na takav odnos odnosno nemogućnosti primjene prethodno izloženog, kao i predloška ugovora u nastavku.  </p>
    <p>Česti su slučajevi u kojima se s menadžerom sklapaju dva ugovora (opcije 1. i 3. u gore navedenom)  - menadžerski ugovor i ugovor o radu, bilo iz namjere poslodavca da tu osobu zadrži i nakon isteka menadžerskog ugovora ili iz neznanja.</p>
    <p>Ugovor o radu zaključuju u cilju reguliranja radnopravnog statusa, a menadžerski ugovor zaključuje u svojstvu menadžera, radi uređivanja ostalih međusobnih prava i obveza. </p>
    <p><strong>Problem može nastati kod namjere istodobnog raskida menadžerskog ugovora i/ili otkaza ugovora o radu, a sastoji se u tome što prestanak menadžerskog ugovora ne dovodi do prestanka ugovora o radu. </strong></p>
    <p>Uzimajući u obzir gore navedeno, u nastavku ovog teksta, ali i u predlošku dokumenta u nastavku obraditi ćemo menadžerski ugovor (opcije 3. i 4. u gore navedenom), kao poseban ugovor koji se dodatno zaključuje uz ugovor o radu odnosno, ali i slučaju kada nije zaključen ugovor o radu između poslodavca i člana uprave, direktora, izvršnog direktora odnosno fizičke osobe koja je u drugom svojstvu prema posebnom zakonu ovlaštena voditi poslove poslodavca.  </p>
    <p>Bitni sastojci menadžerskog ugovora kao posebnog ugovora su:</p>
    <li> uglavci o ovlastima i obvezama menadžera te</li>
    <li>uglavci koji reguliraju materiju naknade za obavljanje poslova menadžera te eventualnih ostalih primanja menadžera.</li>
    <br>
    <p>Sadržaj menadžerskog ugovora treba pravno ocjenjivati, prosuđivati tumačiti prema odredbama Zakona o obveznim odnosima, a ne prema odredbama Zakona o radu pa stoga posebno treba pripaziti da isti ne sadrži odredbe koje proizlaze iz Zakona o radu.</p>
    <p>U pogledu prestanka samog menadžerskog ugovora koji se sklapa uz ugovor o radu (opcija 3. u gore navedenom) ili kao poseban ugovor kada nije zaključen ugovor o radu (opcija 4. u gore navedenom), primjenjuje se ono što su ugovorne stranke ugovorile, a podredno se primjenjuju odredbe Zakona o obveznim odnosima koje reguliraju načine prestanka obveza. </p>
    <p><strong>U slučajevima u kojima i takav dodatni menadžerski ugovor ima (namjerom ili greškom) određene elemente ugovora o radu, isti može biti tumačen kao  mješoviti ugovor (uz obveznopravne elemente sadrži i radnopravne elemente), a od slučaja do slučaja se pravno procjenjuje i prosuđuje radi li se o ugovoru o radu ili menadžerskom ugovoru, stoga valja biti posebno oprezan u pogledu uređivanja sadržaja menadžerskog ugovora na isti način da ne sadrži nikakve elemente radnog prava.</strong></p>
    <p>Dakle, u takvom menadžerskom ugovoru treba izbjegavati ugovaranje odredbi koje proizlaze iz Zakona o radu.</p>
    <p>Primjer takvog menadžerskog ugovora između osobe koja je ovlaštena voditi osobe poslodavca, koji se zaključuje povrh ugovora o radu ili kad nije zaključen ugovor o radu, daje se u nastavku.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- ugovaranje odredbi unutar menadžerskog ugovora koje proizlaze iz Zakona o radu.</strong></p>
    <p>Pojašnjenje: U tom slučaju, navedeni ugovor se ima tumačiti prema Zakonu o radu, što često dovodi do neželjenih posljedica.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac, Društvo),",
      delimiter: `i`
    },
    {
      signature: "Menadžer:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        inSignature: true,
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Menadžer),"
    }
  ],

  headline: "zaključuju sljedeći",
  title: "MENADŽERSKI UGOVOR",

  articles: [
    
      {
        title: 'PREDMET UGOVORA',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ugovorne strane uvodno utvrđuju da je Menadžer imenovan odlukom o imenovanju na mjesto člana uprave Društva te na temelju navedene odluke sklapaju ovaj Ugovor prema uvjetima kako slijedi.\r\nUgovorne strane ovim Ugovorom reguliraju svoja međusobna prava, obveze i ovlaštenja koja na bilo koji način proizlaze iz funkcije Menadžera u Društvu. ',
            },
        ],
    },
    {
        title: 'IMENOVANJE MENADŽERA',
        mandatory: true,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Imenovanje Menadžera obavljeno je u skladu s odredbama Zakona o trgovačkim društvima, osnivačkim aktom Društva te autonomnim aktima Društva, a na temelju odluke Skupštine društva od _____________ 20___. godine, prema kojoj je Menadžer imenovan članom uprave Društva na mandat od ____________ (u daljnjem tekstu: Odluka).',
                value: '',
            }],
      },
      {
        title: 'PROVEDBA UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Na međusobne odnose ugovornih strana prvenstveno će se primjenjivati odredbe ovog Ugovora te opći akti Društva, a ukoliko ovaj Ugovor ne uređuje da odredbe ovog Ugovora ne definiraju neku područje, primjenjivati će se odredbe Zakona o obveznim odnosima.\r\nStranke ovog Ugovora izričito isključuju primjenu Zakona o radu, a poglavito u odnosu na raskid i otkaz ovog Ugovora te pravne posljedice otkaza ovog Ugovora koje se reguliraju daljnjim odredbama ovog Ugovora. ',
                value: '',
            }],
      },
      {
        title: 'PRAVA I DUŽNOSTI MENADŽERA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'U skladu s Odlukom, Menadžer je imenovan na dužnost člana uprave Društva te je u okviru svoje dužnosti obvezan voditi poslove u skladu s pravilima poslovanja Društva. \r\nMenadžer je u svojstvu člana uprave Društva ovlašten zastupati Društvo samostalno i neograničeno te je prema tome odgovoran za zakonit i pravilan rad Društva, kao i za istinitost i pravilnost dokumentacije Društva. \r\nU ostvarivanju prava i obveza koje proizlaze iz funkcije iz ovog Ugovora, Menadžer će naročito: \r\n- obavljati sve poslove i zadatke naznačene Odlukom, \r\n- provoditi odluke Skupštine Društva, \r\n- postupati u skladu s  općim aktima Društva, kao i  uputama dobivenim od Skupštine Društva, \r\n- redovito izvještavati Skupštinu Društva o tijeku poslovanja i financijskom stanju Društva te će u sklopu istog podnositi redovita tromjesečna izvješća o postignutim poslovnim rezultatima Društva i stanju na tržištu, \r\n- u svakom pogledu i na svaki način postupati s pozornošću urednog i savjesnog gospodarstvenika te čuvati i unapređivati ugled i dobar glas Društva.\r\nPoslove i zadatke Menadžer će obavljati u poslovnim prostorijama, odnosno drugim objektima Društva na teritoriju Republike Hrvatske, a po potrebi i izvan sjedišta, ako poslovne aktivnosti Društva to zahtijevaju.  \r\nU osiguravanju prava i obveza koje proizlaze iz njegove dužnosti Menadžer će obavljati poslove Menadžera najmanje u trajanju 40 sati tjedno, 5 dana u tjednu (osim subote i nedjelje), a po potrebi  i više,  ako poslovne aktivnosti Društva to zahtijevaju.   \r\nTijekom obavljanja poslova u periodu od godine dana, Menadžer ima pravo koristiti odmor u trajanju od 30 radnih dana. \r\nO periodu i rasporedu korištenja odmora, Menadžer odlučuje samostalno, pri tome ne dovodeći u pitanje uredno i nesmetano funkcioniranje poslovanja Društva. \r\nU slučaju da Menadžer ne iskoristi u cijelosti svoje pravo na odmor, preostali broj dana može iskoristiti u sljedećoj godini.',
                value: '',
            }],
      },
      {
        title: 'NAKNADA',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Za ostvarenje obveza preuzetih ovim Ugovorom, Društvo će Menadžeru isplaćivati naknadu u iznosu od 40.000,00 kn bruto. Naknada će se isplaćivati mjesečno, do 15-og u mjesecu, za prethodni mjesec.\r\nVisina i način isplate naknade smatraju se poslovnom tajnom.',
                value: '',
            }],
      },
      {
        title: 'NAKNADA TROŠKOVA',
        mandatory: false,
        examplecontent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Menadžer ima pravo na naknadu sljedećih troškova: \r\n- poslovne reprezentacije, \r\n- službenih putovanja u zemlji i inozemstvu, \r\n- članarine u stručnim udruženjima, \r\n- domaće i strane literature, \r\n- posjeta stručnim sajmovima i izložbama u trajanju od 20 dana u tijeku kalendarske godine, \r\n- usavršavanja stranih jezika i drugih oblika usavršavanja, \r\nsve do maksimalnih iznosa utvrđenih posebnom odlukom Skupštine Društva za svaku poslovnu godinu.',
                value: '',
            }],
      },
      {
        title: 'DODATNA NAKNADA (BONUS)',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Pored naknade iz prethodnih članaka ovog Ugovora, Menadžer ima pravo na naknadu za postignute rezultate rada u vidu bonusa. \r\nVisina, način i rokovi isplate ove naknade mogu biti utvrđeni  sustavom nagrađivanja i stimulacija koji se primjenjuje u Društvu, a mogu biti određeni i posebnim sporazumom između Skupštine Društva i Menadžera. \r\nDruštvo zadržava pravo da Menadžeru isplati dodatnu naknadu (bonus), isplatom dijela udjela u dobiti ili ukupnog udjela u dobiti ili na neki drugi način u skladu s važećim zakonskim propisima i općim aktima Društva.',
                value: '',
            }],
      },
      {
        title: 'SMANJENJE PRIMANJA MENADŽERA',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'U skladu sa Zakonom o trgovačkim društvima, u slučaju da dođe do znatnog pogoršanja poslovnih prilika i ostvarivanja slabijih rezultata Društva, čime bi isplaćivanje primanja  Menadžeru predstavljalo tešku nepravdu, Skupština Društvo je ovlaštena donijeti odluku o razmjernom smanjenju primanja Menadžera.',
                value: '',
            }],
      },
      {
        title: 'POSLOVNA TAJNA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Za potrebe ovog Ugovora poslovnom tajnom smatraju se svi podaci, dokumenti, planovi  postupci koji se na bilo koji način odnose ili su u vezi s poslovanjem Društva ili radom djelatnika Društva, a čije bi neovlašteno priopćavanje bilo protivno interesima Društva, a čije bi neovlašteno priopćavanje bilo protivno interesima Društva. \r\nPoslovnom tajnom smatraju se naročito: sheme i podaci o makro i mikro organizaciji, principi rukovođenja i poslovnog informiranja, softver, način postupanja u komercijalnim poslovima i odnosima, poslovne informacije, liste komitenata i poslovnih partnera, te plaće, stimulacije i ostale beneficije svih  djelatnika Društva. \r\nMenadžer se obvezuje na svaki način i neograničeno čuvati  poslovnu tajnu Društva, kako tijekom trajanja ovog Ugovora, tako i nakon njegovog prestanka. Nakon prestanka radnog  odnosa u Društvu, Menadžer će predati Društvu sve izvornike i preslike podataka,  dokumenata, planova i postupaka koji su mu bili na raspolaganju tijekom vršenja njegove funkcije. ',
                value: '',
            }],
      },
      {
        title: 'ZABRANA KONKURENCIJE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Za vrijeme trajanja ovog Ugovora, Menadžer se obvezuje da neće, bez prethodne pisane suglasnosti Društva: \r\n- za svoj ili tuđi račun obavljati bilo kakve poslove u drugim društvima i organizacijama, koji na bilo koji način konkuriraju djelatnosti i poslovanju Društva, osim  u slučajevima kada ga na to obveže Skupština ili drugi nadležni organ Društva, \r\n- biti osnivač ili suvlasnik društva ili organizacije ili član uprave ili nadzornog odbora društva koje na bilo koji način konkurira djelatnosti i poslovanju Društva, osim u onim društvima, i organizacijama u kojima je Društvo dioničar, vlasnik ili suvlasnik ili drugih organizacija nad kojima Društvo ima kontrolu, \r\n- obavljati poslove za svoj osobni ili tuđi interes u prostorijama Društva. \r\nMenadžer se obvezuje da 1 (jednu) godinu nakon prestanka radnog odnosa u Društvu bez prethodne pisane suglasnosti Društva u bilo kojem svojstvu ili po bilo kojoj osnovi neće obavljati poslove iz osnovne djelatnosti Društva te da se neće zaposliti kod druge osobe koja je u tržišnom natjecanju s Društvom, a niti za svoj račun ili račun treće osobe sklapati poslove kojima se natječe s Društvo. \r\nMenadžer se nadalje obvezuje da  informacije i poslovne kontakte koje je na neposredan ili posredan način stekao tijekom obnašanja svoje menadžerske funkcije u  Društvu prema ovom Ugovoru, neće koristiti za svoj ili tuđi račun za vrijeme trajanja ovog Ugovora, kao i neograničeno  nakon prestanka važenja ovog Ugovora. \r\nMenadžer će snositi i svaku materijalnu odgovornost za štetu koju Društvo pretrpi zbog kršenja ovih odredbi.',
                value: '',
            }],
      },
      {
        title: 'PRAVA INDUSTRIJSKOG VLASNIŠTVA I AUTORSKA PRAVA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Društvo zadržava materijalna prava na izumima, tehničkim unapređenjima i autorskim djelima koje je Menadžer stvorio na radnom mjestu ili sredstvima Društva, odnosno podacima koji su mu stavljeni na raspolaganje radi izvršavanja radnih zadataka na temelju ovog Ugovora. \r\nOva prava gase se po isteku roka od 5 (pet) godina od prve primjene izuma, unapređenja ili autorskog djela.\r\nDruštvo se obvezuje o svom trošku izvršiti potrebne radnje u svrhu registracije tvorevina iz prethodnog stavka ovog članka kod nadležnih organa.                 ',
                value: '',
            }],
        },
        {
            title: 'TRAJANJE UGOVORA',
            mandatory: true,
            exampleContent: true, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor se sklapa se na rok određen Odlukom, tj. na rok od 5 godina, počevši od ______________ godine. ',
                    value: '',
                }],
            },
     
            {
                title: 'OTKAZ I RASKID UGOVORA, OPOZIV',
                mandatory: false,
                exampleContent: true,
                statements: [
                    {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Svaka ugovorna strana može otkazati ovaj Ugovor iz bilo kojeg razloga i bez obrazloženja, pisanom obavijesti drugoj ugovornoj strani, uz otkazni rok od 60 (šezdeset) dana. \r\nMenadžer ima pravo na jednostrani raskid Ugovora iz razloga smanjenja primanja uslijed znatnog pogoršanja poslovnih prilika i ostvarivanja slabijih rezultata društva, uz otkazni rok od 2 (dva) mjeseca. \r\nSkupština Društva ima pravo opozvati Menadžera s mjesta člana Uprave u slučaju ako Menadžer ne izvršava svoje radne zadatke sukladno ovom Ugovoru, a naročito ako u svojem radu izvrši neku od teških povreda dužnosti ili nastupi njegova trajna nesposobnost za obavljanje poslova upravljanja Društvo. \r\nU slučaju iz prethodnog stavka, s danom donošenja odluke od strane Skupštine društva,  Menadžeru prestaje dužnost člana Uprave.',
                        value: '',
                    }],
                }, 
{
title: 'OTPREMNINA',
mandatory: false,
exampleContent: true,
statements: [
    {
        type: 'text',
        mandatory: true,
        editable: true,
        content: 'U slučaju jednostranog otkaza ugovora od strane Društva, iz neskrivljenih razloga od strane Menadžera, Društvo se obvezuje isplatiti na ime otpremnine svotu koja je jednaka svoti od 6 mjesečnih bruto naknada Menadžera ostvarenih u razdoblju koje je prethodilo raskidu i to u roku od 45 dana od dana otkaza ugovora.',
        value: '',
    }],
}, 
    {
      title: "ZAVRŠNE ODREDBE",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: `Ovaj Ugovor se primjenjuje od dana potpisivanja.\r\nIzmjene i dopune ovog Ugovora moraju biti u pisanom obliku.\r\nEventualne sporove nastale u vezi s Ugovorom, Poslodavac i Menadžer pokušati će riješiti sporazumno, u protivnom, nadležan je stvarno nadležni sud prema sjedištu Poslodavca.`,
        }]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],

};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/223_menadzerski_ugovor_poseban_ugovor.ts